// AI-assisted: Claude 2026-08-08, human-reviewed: ausstehend
// Farb-Themes: setzt data-theme auf <html>, merkt die Wahl lokal und hält
// die Browser-Leiste (meta theme-color) farblich passend.
// ponytail: Wahl liegt in localStorage (je Gerät); users.theme nachrüsten,
// falls die Wahl mal über Geräte hinweg mitwandern soll.

const KEY = "fithub:theme"

/* Safari-Privatmodus & Co. werfen bei localStorage — Theme fällt dann
   einfach auf den Standard zurück statt die App zu reißen. */
function lies(): string | null {
  try { return localStorage.getItem(KEY) } catch { return null }
}
function merke(id: string): void {
  try { localStorage.setItem(KEY, id) } catch { /* nicht speicherbar — egal */ }
}

export interface ThemeDef {
  id: string
  name: string
  dunkel: boolean
  /** Vorschau-Farben fürs Auswahl-Feld: [Grund, Kraftfarbe, Akzent] */
  preview: [string, string, string]
}

export const THEMES: ThemeDef[] = [
  { id: "wald", name: "Papier & Wald", dunkel: false, preview: ["#F7F4EC", "#1E3D2F", "#6B8F71"] },
  { id: "nacht", name: "Wald bei Nacht", dunkel: true, preview: ["#141A16", "#4C8363", "#6FAE83"] },
  { id: "dunkel", name: "Dunkel", dunkel: true, preview: ["#141619", "#4A5A68", "#7A93A6"] },
  { id: "ozean", name: "Ozean", dunkel: true, preview: ["#0E1922", "#3E7CA6", "#52A7C7"] },
  { id: "lagune", name: "Lagune", dunkel: false, preview: ["#EFF6F3", "#0E5A52", "#379A87"] },
  { id: "glut", name: "Glut", dunkel: true, preview: ["#191512", "#C05C36", "#D9A45C"] },
  { id: "beere", name: "Beere", dunkel: true, preview: ["#1C1218", "#A83A60", "#C25E80"] },
  { id: "wueste", name: "Wüste", dunkel: false, preview: ["#F6EFE0", "#9C532A", "#B0793B"] },
  { id: "nordlicht", name: "Nordlicht", dunkel: true, preview: ["#0D1322", "#2E9E77", "#7C74D9"] },
  { id: "runes", name: "Runes", dunkel: true, preview: ["#171916", "#8C6E3B", "#7FA083"] },
  { id: "neon", name: "Neon", dunkel: true, preview: ["#0D0C12", "#D62E74", "#9D4EE8"] },
]

export function currentTheme(): string {
  const stored = lies()
  return THEMES.some((t) => t.id === stored) ? (stored as string) : "wald"
}

function setze(theme: ThemeDef): void {
  if (theme.id === "wald") delete document.documentElement.dataset.theme
  else document.documentElement.dataset.theme = theme.id
  // Browser-Leiste färbt mit (PWA-Gefühl); Kraftfarbe = Kopf der App
  const meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')
  if (meta) meta.content = theme.preview[1]
}

export function applyTheme(id: string): void {
  const theme = THEMES.find((t) => t.id === id) ?? THEMES[0]
  setze(theme)
  merke(theme.id)
}

export function initTheme(): void {
  applyTheme(currentTheme())
}

// ── „Training immer dunkel" (Optionen → Aussehen) ──

const TRAINING_DUNKEL_KEY = "fithub:training-dunkel"

export function istDunkel(id: string): boolean {
  return THEMES.find((t) => t.id === id)?.dunkel ?? false
}

export function trainingDunkel(): boolean {
  try { return localStorage.getItem(TRAINING_DUNKEL_KEY) === "an" } catch { return false }
}

export function setTrainingDunkel(an: boolean): void {
  try {
    if (an) localStorage.setItem(TRAINING_DUNKEL_KEY, "an")
    else localStorage.removeItem(TRAINING_DUNKEL_KEY)
  } catch { /* nicht speicherbar — egal */ }
}

/** Theme nur ANZEIGEN, ohne die gespeicherte Wahl anzufassen —
    für den Trainings-Tab; null stellt die gespeicherte Wahl wieder her. */
export function themeTemporaer(id: string | null): void {
  const ziel = id === null ? currentTheme() : id
  setze(THEMES.find((t) => t.id === ziel) ?? THEMES[0])
}
